import { twMerge } from 'tailwind-merge';

import { GameStatusTag, IGame } from '../constants/games.constants';
import { ROUTES } from 'constants/routes.constant';

import Button from 'components/buttons/Button';

import GameLink from '../gameLink/GameLink';
import GameTag from '../gameTag/GameTag';

const GamesCard = ({ game }: { game: IGame }) => {
  const renderGameStatusTagVariant = (status: string) => {
    const adapt = {
      [GameStatusTag.ComingSoon]: 'yellow',
      [GameStatusTag.StakingClosed]: 'blue',
    };

    // @ts-ignore
    return adapt[status] ?? 'green';
  };

  return (
    <div className="tw-relative tw-w-full tw-overflow-hidden tw-rounded-2xl tw-bg-backgroundColorMedium">
      <div
        className="tw-aspect-[408/260] tw-bg-contain tw-bg-no-repeat"
        style={{ backgroundImage: `url(${game.image})` }}
      />
      <GameTag className="tw-absolute tw-right-4 tw-top-4" variant={renderGameStatusTagVariant(game.status)}>
        {game.status}
      </GameTag>
      <div className="tw-p-5 lg:tw-pt-6">
        <h2 className="tw-mb-2 tw-line-clamp-1 tw-text-left tw-text-[26px]/[28px] tw-uppercase tw-text-white lg:tw-mb-4 lg:tw-text-[32px]/[28px]">
          {game.title}
        </h2>
        <div className="tw-mb-4 tw-flex tw-gap-2">
          {game.type.map((typeTag) => (
            <div
              key={typeTag}
              className="tw-rounded-md tw-bg-backgroundColorLight tw-px-1.5 tw-py-2 tw-text-center tw-text-base tw-font-semibold tw-uppercase !tw-leading-none tw-text-white"
            >
              {typeTag}
            </div>
          ))}
        </div>
        <div className="tw-mb-5 tw-flex tw-h-[32px] tw-gap-2.5">
          {game.links.map((link) => (
            <GameLink
              key={link.type}
              {...link}
              className="tw-h-[32px] tw-w-[32px] tw-fill-menuLinkColor hover:tw-fill-turquoise"
            />
          ))}
        </div>
        <Button
          size="medium"
          color={!game.description ? 'disabled-outline' : 'white-outline'}
          twClassName={twMerge('tw-w-full', !game.description && 'tw-pointer-events-none')}
          asLink
          link={`${ROUTES.GAMES}/${game.href}`}
          target="_self"
          disabled={!game.description}
        >
          More details
        </Button>
      </div>
    </div>
  );
};

export default GamesCard;
